/* OVYRE Maca page (v2) — gallery, offers, accordions, sticky CTA */
(function () {
  'use strict';
  if (window.__macaPageInit) return;
  window.__macaPageInit = true;
  var root = document;

  /* ---------- Gallery ---------- */
  var gallery = root.querySelector('[data-gallery]');
  if (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot]'));
    var current = 0;

    function go(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      slides.forEach(function (s, idx) { s.setAttribute('aria-hidden', idx === current ? 'false' : 'true'); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    // Touch swipe
    var startX = null;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    // Keyboard
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(current - 1);
      if (e.key === 'ArrowRight') go(current + 1);
    });
  }

  /* ---------- Offer selector ---------- */
  var offersBox = root.querySelector('[data-offers]');
  var forms = Array.prototype.slice.call(root.querySelectorAll('[data-maca-form]'));
  function money(n) {
    var f = parseFloat(n);
    return '$' + f.toFixed(2);
  }
  function selectOffer(label) {
    var id = label.getAttribute('data-variant-id');
    var price = label.getAttribute('data-price');
    offersBox.querySelectorAll('.maca-offer').forEach(function (o) {
      var on = o === label;
      o.classList.toggle('is-selected', on);
      var r = o.querySelector('input[type=radio]');
      if (r) r.checked = on;
    });
    forms.forEach(function (f) {
      var inp = f.querySelector('[data-maca-variant]');
      if (inp) inp.value = id;
    });
    root.querySelectorAll('[data-maca-cta-price]').forEach(function (s) { s.textContent = money(price); });
    var bottles = label.getAttribute('data-bottles');
    if (bottles) { root.querySelectorAll('[data-maca-cta-bottles]').forEach(function (s) { s.textContent = bottles; }); }
    var stickyPrice = root.querySelector('[data-maca-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = money(price);
  }
  if (offersBox) {
    offersBox.querySelectorAll('.maca-offer').forEach(function (label) {
      label.addEventListener('click', function () { selectOffer(label); });
    });
  }

  /* ---------- Accordions ---------- */
  root.querySelectorAll('[data-acc]').forEach(function (acc) {
    acc.querySelectorAll('.maca-acc__item').forEach(function (item) {
      var btn = item.querySelector('.maca-acc__btn');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });

  /* ---------- Urgency countdown (to midnight, local time) ---------- */
  var cd = root.querySelector('[data-maca-countdown]');
  if (cd) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date(), end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      cd.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Sticky mobile CTA ---------- */
  var sticky = root.querySelector('[data-maca-sticky]');
  var heroCta = root.querySelector('.maca-hero [data-maca-cta]');
  var finalCta = root.querySelector('.maca-final [data-maca-cta]');
  function onScroll() {
    if (!sticky) {
      return;
    }
    var heroBottom = heroCta ? heroCta.getBoundingClientRect().bottom : 0;
    var finalTop = finalCta ? finalCta.getBoundingClientRect().top : Infinity;
    var show = heroBottom < 0 && finalTop > window.innerHeight;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- Sticky: true add-to-cart (opens cart drawer) ---------- */
  var stickyForm = sticky ? sticky.querySelector('form') : null;
  var stickyBtn = sticky ? sticky.querySelector('[data-maca-sticky-atc]') : null;
  if (stickyForm && stickyBtn) {
    stickyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = stickyForm.querySelector('[data-maca-variant]');
      var variantId = variantInput && variantInput.value;
      if (!variantId || stickyBtn.disabled) return;
      stickyBtn.disabled = true;
      var original = stickyBtn.innerHTML;
      stickyBtn.textContent = 'ADDING...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { stickyBtn.disabled = false; stickyBtn.innerHTML = original; });
    });
  }

  /* ---------- Scroll-to-offer links ---------- */
  root.querySelectorAll('[data-scroll-cta]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- Reviews slider: infinite loop (arrows + swipe) ---------- */
  // iOS Safari fights native smooth scrolling inside mandatory scroll-snap
  // containers, so animate the scroll manually with snapping paused.
  function revSmoothScroll(el, targetLeft, done) {
    var max = Math.max(0, el.scrollWidth - el.clientWidth);
    var target = Math.max(0, Math.min(max, targetLeft));
    var start = el.scrollLeft;
    if (Math.abs(target - start) < 2) { if (done) done(); return; }
    var dur = 350, t0 = null;
    el.style.scrollSnapType = 'none';
    function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.scrollLeft = start + (target - start) * e;
      if (p < 1) { requestAnimationFrame(frame); }
      else { el.style.scrollSnapType = ''; if (done) done(); }
    }
    requestAnimationFrame(frame);
  }

  function initRevsec() {
    var revsec = root.querySelector('#maca-reviews');
    if (!revsec || revsec.dataset.revsecInit) return;
    revsec.dataset.revsecInit = '1';
    var viewport = revsec.querySelector('.maca-revsec__viewport');
    var track = revsec.querySelector('[data-reviews]');
    var nav = revsec.querySelector('[data-revsec-nav]');
    if (!viewport || !track || !nav) return;
    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) { nav.style.display = 'none'; return; }

    // Clone the full set before and after so the loop never ends.
    function cloneSet(intoStart) {
      var frag = document.createDocumentFragment();
      originals.forEach(function (card) {
        var c = card.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        frag.appendChild(c);
      });
      if (intoStart) track.insertBefore(frag, track.firstChild);
      else track.appendChild(frag);
    }
    cloneSet(true);
    cloneSet(false);

    var n = originals.length;
    var all = Array.prototype.slice.call(track.children);
    var startOffset = 0, oneSet = 0;

    function gap() { return parseFloat(getComputedStyle(track).gap) || 16; }
    function cardStep() {
      var w = all[0].getBoundingClientRect().width;
      return (w || viewport.clientWidth) + gap();
    }
    function measure() {
      var first = all[n];
      startOffset = first.offsetLeft;
      var last = all[2 * n - 1];
      oneSet = (last.offsetLeft + last.offsetWidth) - startOffset;
    }
    function jump(dLeft) {
      viewport.style.scrollSnapType = 'none';
      viewport.scrollLeft += dLeft;
      void viewport.offsetWidth;
      viewport.style.scrollSnapType = '';
    }
    function normalize() {
      if (!oneSet) return;
      var sl = viewport.scrollLeft;
      if (sl < startOffset - 2) jump(oneSet);
      else if (sl >= startOffset + oneSet - 2) jump(-oneSet);
    }

    var prev = revsec.querySelector('[data-revsec-prev]');
    var next = revsec.querySelector('[data-revsec-next]');
    function go(dir) {
      normalize();
      revSmoothScroll(viewport, viewport.scrollLeft + dir * cardStep(), normalize);
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    // After a swipe settles, silently wrap around if we're sitting on clones.
    var settle = 0;
    viewport.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(normalize, 140);
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); normalize(); });

    measure();
    viewport.scrollLeft = startOffset;
  }
  initRevsec();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#maca-reviews')) initRevsec();
  });

})();
